import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "order-issue-editor"
}
const _hoisted_2 = { class: "order-issue__head" }
const _hoisted_3 = { class: "notice error space-v1" }
const _hoisted_4 = {
  key: 0,
  class: "notice warn"
}
const _hoisted_5 = {
  key: 1,
  class: "action__note-input"
}
const _hoisted_6 = { class: "order-issue__section" }
const _hoisted_7 = { class: "order-issue__events-list" }
const _hoisted_8 = {
  key: 2,
  class: "event-details"
}
const _hoisted_9 = { class: "event-metadata" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 3,
  class: "event-details"
}
const _hoisted_13 = { class: "order-issue__section" }
const _hoisted_14 = { class: "order-issue__section" }
const _hoisted_15 = { class: "order-issue__actions-container order_bottom_sheet" }
const _hoisted_16 = { class: "action-group wide" }
const _hoisted_17 = { class: "bold" }
const _hoisted_18 = { class: "bold" }
const _hoisted_19 = { class: "medium" }
const _hoisted_20 = { class: "action-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return ($setup.props.modelValue)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString($setup.errorMessage), 1),
          ($setup.props.modelValue.operational_notes?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Operational Note — " + _toDisplayString($setup.props.modelValue.operational_notes), 1))
            : _createCommentVNode("", true)
        ]),
        (!$setup.addingNote)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              class: "action__note",
              onClick: $setup.addNote,
              color: "primary",
              unelevated: "",
              rounded: ""
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("+ Add note")
              ])),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_q_input, {
                modelValue: $setup.note,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.note) = $event)),
                type: "textarea",
                autogrow: "",
                autofocus: ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_q_btn, {
                class: "action__note",
                disabled: !$setup.note.length,
                onClick: $setup.updateNote,
                color: "primary",
                unelevated: "",
                rounded: ""
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("Add note")
                ])),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_q_btn, {
                class: "action__note",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.addingNote = false)),
                unelevated: "",
                rounded: ""
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("Cancel")
                ])),
                _: 1
              })
            ])),
        _createElementVNode("section", _hoisted_6, [
          _cache[8] || (_cache[8] = _createElementVNode("h6", { class: "order-issue__section-head" }, "Latest Events", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode($setup["OrderEventTimeline"], {
              id: $setup.props.modelValue.sys.id,
              sticky: ['error']
            }, {
              default: _withCtx(({ metadata }) => [
                (metadata?.error || metadata?.failed || _ctx.meta?.name === 'ServiceErrror')
                  ? (_openBlock(), _createBlock($setup["OrderErrorDetails"], {
                      key: 0,
                      order: $setup.props.modelValue.sys.id,
                      meta: metadata
                    }, null, 8, ["order", "meta"]))
                  : (metadata?.fulfillment)
                    ? (_openBlock(), _createBlock($setup["OrderFulfillmentDetails"], {
                        key: 1,
                        order: $setup.props.modelValue.sys.id,
                        data: $setup.fulfillmentData
                      }, null, 8, ["order", "data"]))
                    : metadata
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("dl", _hoisted_9, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(metadata, (value, key) => {
                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                _createElementVNode("dt", null, _toDisplayString(key), 1),
                                ((typeof value === 'object'))
                                  ? (_openBlock(), _createElementBlock("dd", _hoisted_10, [
                                      _createElementVNode("pre", null, _toDisplayString(value), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("dd", _hoisted_11, _toDisplayString(typeof value === 'boolean' ? (value ? 'yes' : 'no') : value), 1))
                              ], 64))
                            }), 256))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_12, "No details"))
              ]),
              _: 1
            }, 8, ["id"])
          ])
        ]),
        _createElementVNode("section", _hoisted_13, [
          _createVNode($setup["AddressEditor"], {
            modelValue: $setup.props.modelValue.shipping_address,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.props.modelValue.shipping_address) = $event)),
            id: $setup.props.modelValue.sys.id
          }, null, 8, ["modelValue", "id"])
        ]),
        _createElementVNode("section", _hoisted_14, [
          _cache[9] || (_cache[9] = _createElementVNode("h6", { class: "order-issue__section-head" }, "Products", -1)),
          _createVNode($setup["DraftProductList"], {
            readonly: true,
            items: $setup.props.modelValue.products,
            catalogue: $setup.props.modelValue.catalogue,
            onSearch: $setup.searchProducts
          }, null, 8, ["items", "catalogue"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("header", _hoisted_16, [
            _createElementVNode("h3", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, _toDisplayString($setup.props.modelValue.reference), 1),
              ($props.link)
                ? (_openBlock(), _createBlock($setup["ExternalLinkIcon"], {
                    key: 0,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.openMirrorUrl($props.link)))
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("h6", _hoisted_19, _toDisplayString($setup.props.modelValue.service), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["action-group wide", { fullwidth: $setup.isMobile }])
          }, [
            _createVNode(_component_q_btn_dropdown, {
              class: "action__resolve",
              onClick: $setup.resolveIssue,
              color: "primary",
              split: "",
              unelevated: "",
              rounded: "",
              label: "Mark as resolved"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.statusOptions, (key, label) => {
                  return _createVNode(_component_q_list, null, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        clickable: "",
                        onClick: ($event: any) => ($setup.resolveIssue(key))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(label), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 2
                  }, 1024)
                }), 64))
              ]),
              _: 1
            }),
            _createVNode(_component_q_btn, {
              class: "action__reset",
              onClick: $setup.resetOrder,
              color: "primary",
              unelevated: "",
              outline: "",
              rounded: ""
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("Reset order")
              ])),
              _: 1
            })
          ], 2),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_q_btn, {
              class: "close-details",
              round: "",
              flat: "",
              icon: "clear",
              size: "sm",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
            })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}